import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	label: {
		id: 'move-single-board.current-location.label',
		defaultMessage: 'Current location',
		description: '',
	},
});
export default messages;
